import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const Ctx = createContext(null);

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(null);
  const refresh = useCallback(async () => {
    try {
      // Cache-bust so admin edits are reflected immediately (browsers may cache GET responses)
      const r = await api.get(`/settings/public?_=${Date.now()}`);
      setSettings(r.data);
      return r.data;
    } catch { return null; }
  }, []);
  useEffect(() => { refresh(); }, [refresh]);
  return <Ctx.Provider value={{ settings: settings || {}, refresh }}>{children}</Ctx.Provider>;
}

export const useSettings = () => useContext(Ctx) || { settings: {}, refresh: () => {} };
